module.exports = __webpack_public_path__ + "smartphone_76x76.bbd14a168098e2997d75ffa03dfa2edd.png";